import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './logo.html' with { type: 'html' };

export default {
	name: 'CLogo',
	components: {
		cSvg
	},
	props: {
		brand: {
			type: String,
			default: 'avast'
		},
		headline: {
			type: String,
			default: ''
		},
		separator: {
			type: Boolean,
			default: false
		},
		design: {
			type: String,
			default: 'dark'
		}
	},
	template
};
